import { resolveServiceUrl } from '../../api/api-config';
import { createApiClient } from '../../api/create-api-client';
import createApiKey from './create-api-key/create-api-key';
import deleteApiKey from './delete-api-key/delete-api-key';
import getApiKeys from './get-api-keys/get-api-keys';
import setApiKeyExpiration from './set-api-key-expiration/set-api-key-expiration';
import setApiKeyStatus from './set-api-key-status/set-api-key-status';

const client = createApiClient({ uri: resolveServiceUrl('API_KEY_URL') });
const apiKeySettingsService = {
  getApiKeys: getApiKeys(client),
  createApiKey: createApiKey(client),
  deleteApiKey: deleteApiKey(client),
  setApiKeyStatus: setApiKeyStatus(client),
  setApiKeyExpiration: setApiKeyExpiration(client),
};

export default apiKeySettingsService;
